import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  formControl: {
    minWidth: theme.spacing(25),
  },
  select: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,

    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      minHeight: theme.spacing(4),
    },
    '& .MuiSelect-icon': {
      color: theme.palette.text.primary,
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
    width: '100%',
  },
  rowText: {
    color: theme.palette.text.primary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  languageCode: {
    fontWeight: 700,
  },
}));
